import { render, staticRenderFns } from "./DeclinedPayment.vue?vue&type=template&id=451868ed&scoped=true"
import script from "./DeclinedPayment.vue?vue&type=script&lang=js"
export * from "./DeclinedPayment.vue?vue&type=script&lang=js"
import style0 from "./DeclinedPayment.vue?vue&type=style&index=0&id=451868ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451868ed",
  null
  
)

export default component.exports